var React = require('react');

function SingleChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.08828 23.6571L18.2376 12.8286C18.4831 12.5428 18.565 12.2857 18.565 12C18.565 11.6286 18.5104 11.4857 18.2649 11.2L8.03372 0.342857C7.62447 -0.114286 6.94239 -0.114286 6.50586 0.342857L5.74193 1.14286C5.33269 1.60001 5.33269 2.31429 5.74193 2.77143L14.4453 12.0286L5.7965 21.2286C5.38725 21.6856 5.38725 22.4 5.7965 22.8572L6.56043 23.6571C6.96967 24.1143 7.65175 24.1143 8.08828 23.6571Z","fill":"currentColor"}));
}

SingleChevronRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SingleChevronRight;

SingleChevronRight.default = SingleChevronRight;
